
import { Component } from 'vue-property-decorator';
import Base from './Base.vue';

@Component
export default class GitlabIssue extends Base {
  get env() {
    return process.env.NODE_ENV;
  }

  open(bug = false) {
    // eslint-disable-next-line no-alert
    const title = window.prompt('En quelques mots ? (titre)');
    if (!title) return;

    // const prompt = window.prompt('Détail ?');
    let message = `URL: ${window.location.href}\n\nSaisissez le détail ici...\n\n`;
    // if (prompt) message = message.concat(`${prompt}\n\n`);

    let labels: string[] = [];
    labels = labels.concat(this.additionalLabels);

    if (bug && this.bugLabel) labels.push(this.bugLabel);
    if (!bug && this.featureLabel) labels.push(this.featureLabel);

    labels.forEach((label) => {
      message = message.concat(`/label ~${label}\n`);
    });

    if (this.assignees.length) message = message.concat('\n');
    this.assignees.forEach((assignee) => {
      message = message.concat(`/assign @${assignee}\n`);
    });

    window.open(
      `${this.gitlabNewIssueUrl}?issue[title]=${encodeURIComponent(
        `${bug ? 'Bug: ' : ''}${title}`,
      )}&issue[description]=${encodeURIComponent(message)}`,
    );
  }

  get assignees(): string[] {
    return process.env.VUE_APP_GITLAB_ASSIGNEES?.split(',') || [];
  }

  get gitlabNewIssueUrl() {
    return process.env.VUE_APP_GITLAB_NEW_ISSUE_URL;
  }

  get additionalLabels(): string[] {
    return process.env.VUE_APP_GITLAB_ADDITIONAL_LABELS?.split(',') || [];
  }

  get bugLabel(): string | undefined {
    return process.env.VUE_APP_GITLAB_BUG_LABEL;
  }

  get featureLabel(): string | undefined {
    return process.env.VUE_APP_GITLAB_FEATURE_LABEL;
  }

  get active() {
    return Boolean(this.assignees.length && this.bugLabel && this.gitlabNewIssueUrl);
  }
}
